module.exports = "/_next/static/images/good-7c5bebcdcaca8cc647af65e495d3be9a.png";